// extracted by mini-css-extract-plugin
export default {"dialog":"style--dialog--2982e1"};